import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TimeslotApiUtils = {
  fetch(options = {}) {
    let query = '?';
    query += `timeZone=${options.timeZone}`;
    if (options.date) {
      query += `&date=${options.date}`;
    }
    if (options.time) {
      query += `&time=${options.time}`;
    }
    if (options.startTime) {
      query += `&startTime=${options.startTime}`;
    }
    if (options.endTime) {
      query += `&endTime=${options.endTime}`;
    }
    if (options.sortOption) {
      query += `&sortOption=${options.sortOption}`;
    }
    if (options.page) {
      query += `&page=${options.page}`;
    }
    return xhr(ApiConstants.FetchSlotStatus + query);
  },

  fetchByTutor(tutorId, options = {}) {
    let query = '?';
    let first = true;
    for (const key of Object.keys(options)) {
      if (!first) {
        query += '&';
      }
      query += `${key}=${options[key]}`;
      if (first) {
        first = false;
      }
    }
    return xhr(`${ApiConstants.FetchSlotStatus}/${tutorId}${query}`);
  },

  fetchAvailabilities(range, timeZone) {
    let query = `range=${range}`;
    if (timeZone) {
      query += `&timeZone=${encodeURIComponent(timeZone)}`;
    }
    return xhr(
      `${ApiConstants.Base}/booking-calendar/load-availabilities?${query}`,
    );
  },

  fetchTutorsOnSlot(timestamp) {
    return xhr(
      `${ApiConstants.Base}/booking-calendar/tutors?timestamp=${timestamp}`,
    );
  },
};

export default TimeslotApiUtils;
